import Vue from 'vue'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
// import all locales used in i18n
import 'moment/locale/zh-tw'
import 'moment/locale/zh-cn'
import 'moment/locale/ja'
import 'moment/locale/fr'
import 'moment/locale/de'
import 'moment/locale/nl'
import 'moment/locale/ar'
import 'moment/locale/es'

Vue.use(VueMoment, {
  moment
})
